"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var idm_report_export_service_client_js_1 = require("@synisys/idm-report-export-service-client-js");
var core_1 = require("@angular/core");
var forms_1 = require("@angular/forms");
var text_style_converter_1 = require("../../converter/text-style-converter");
var COLOR_PICKER_CONTROL_VALUE_ACCESSOR = {
    provide: forms_1.NG_VALUE_ACCESSOR,
    useExisting: core_1.forwardRef(function () { return SisTextStyleComponent; }),
    multi: true
};
var SisTextStyleComponent = /** @class */ (function () {
    function SisTextStyleComponent() {
        this.styleChanged = new core_1.EventEmitter();
    }
    SisTextStyleComponent.prototype.ngOnInit = function () {
    };
    SisTextStyleComponent.prototype.writeValue = function (obj) {
        if (obj) {
            this.textStyle = obj;
        }
    };
    SisTextStyleComponent.prototype.registerOnChange = function (fn) {
        this._onChangeCallback = fn;
    };
    SisTextStyleComponent.prototype.registerOnTouched = function (fn) {
        this._onTouchedCallback = fn;
    };
    SisTextStyleComponent.prototype.getSelectedElementAlignment = function () {
        return this.textStyle ? this.textStyle.align : undefined;
    };
    Object.defineProperty(SisTextStyleComponent.prototype, "isBold", {
        get: function () {
            return this.textStyle ? this.textStyle.isBold : false;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisTextStyleComponent.prototype, "isItalic", {
        get: function () {
            return this.textStyle ? this.textStyle.isItalic : false;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisTextStyleComponent.prototype, "isUnderline", {
        get: function () {
            return this.textStyle ? this.textStyle.isUnderline : false;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisTextStyleComponent.prototype, "backgroundColor", {
        get: function () {
            return this.textStyle ? (this.textStyle.backgroundColor ? this.textStyle.backgroundColor : null) : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisTextStyleComponent.prototype, "color", {
        get: function () {
            return this.textStyle ? (this.textStyle.color ? this.textStyle.color : '') : '';
        },
        enumerable: true,
        configurable: true
    });
    SisTextStyleComponent.prototype.getSelectedElementFontFamily = function () {
        return this.textStyle ? (this.textStyle.fontName ? this.textStyle.fontName.getValue() : idm_report_export_service_client_js_1.FontName.ROBOTO.getValue()) : idm_report_export_service_client_js_1.FontName.ROBOTO.getValue();
    };
    SisTextStyleComponent.prototype.getSelectedElementFontSize = function () {
        return this.textStyle ? (this.textStyle.fontSize ? this.textStyle.fontSize : '12') : '12';
    };
    SisTextStyleComponent.prototype.onFontSizeChange = function (newFontSize) {
        if (this.textStyle.fontSize !== +newFontSize) {
            this.textStyle.fontSize = +newFontSize;
            this.styleChanged.emit();
        }
        this._onChangeCallback(this.textStyle);
    };
    SisTextStyleComponent.prototype.onBoldChange = function (value) {
        if (value === true) {
            this.textStyle.isBold = value;
        }
        else {
            this.textStyle.isBold = undefined;
        }
        this.styleChanged.emit();
        this._onChangeCallback(this.textStyle);
    };
    SisTextStyleComponent.prototype.onItalicChange = function (value) {
        if (value === true) {
            this.textStyle.isItalic = value;
        }
        else {
            this.textStyle.isItalic = undefined;
        }
        this.styleChanged.emit();
        this._onChangeCallback(this.textStyle);
    };
    SisTextStyleComponent.prototype.onUnderlineChange = function (value) {
        if (value === true) {
            this.textStyle.isUnderline = value;
        }
        else {
            this.textStyle.isUnderline = undefined;
        }
        this.styleChanged.emit();
        this._onChangeCallback(this.textStyle);
    };
    SisTextStyleComponent.prototype.onAlignChange = function (newAlignment) {
        var align;
        if (typeof newAlignment !== 'undefined' && this.textStyle.align !== newAlignment) {
            switch (+newAlignment) {
                case idm_report_export_service_client_js_1.Align.CENTER:
                    align = idm_report_export_service_client_js_1.Align.CENTER;
                    break;
                case idm_report_export_service_client_js_1.Align.LEFT:
                    align = idm_report_export_service_client_js_1.Align.LEFT;
                    break;
                case idm_report_export_service_client_js_1.Align.RIGHT:
                    align = idm_report_export_service_client_js_1.Align.RIGHT;
                    break;
                default:
                    throw new Error("Unknown alignment : " + newAlignment + " ");
            }
            this.textStyle.align = align;
            this.styleChanged.emit();
        }
        this._onChangeCallback(this.textStyle);
    };
    SisTextStyleComponent.prototype.onColorChange = function (newColor) {
        if (this.textStyle.color !== newColor) {
            this.textStyle.color = newColor;
            this.styleChanged.emit();
        }
        this._onChangeCallback(this.textStyle);
    };
    SisTextStyleComponent.prototype.onBackgroundColorChange = function (newColor) {
        if (this.textStyle.backgroundColor !== newColor) {
            this.textStyle.backgroundColor = newColor;
            this.styleChanged.emit();
        }
        this._onChangeCallback(this.textStyle);
    };
    SisTextStyleComponent.prototype.onFontFamilyChange = function (newFont) {
        var fontName = text_style_converter_1.TextStyleConverter.convertStringToFontName(newFont);
        if (this.textStyle.fontName !== fontName) {
            this.textStyle.fontName = fontName;
            this.styleChanged.emit();
        }
        this._onChangeCallback(this.textStyle);
    };
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], SisTextStyleComponent.prototype, "styleChanged", void 0);
    SisTextStyleComponent = __decorate([
        core_1.Component({
            
            selector: 'sis-text-style',
            template: require('./sis-text-style.component.html'),
            styles: [require('./sis-text-style.component.css')],
            providers: [COLOR_PICKER_CONTROL_VALUE_ACCESSOR]
        }),
        __metadata("design:paramtypes", [])
    ], SisTextStyleComponent);
    return SisTextStyleComponent;
}());
exports.SisTextStyleComponent = SisTextStyleComponent;
//# sourceMappingURL=sis-text-style.component.js.map